import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { Star, Building2, User, ArrowRight } from 'lucide-react';
import { API_BASE_URL } from '../config/api';
import axios from 'axios';

export const MemberSpotlight = () => {
  const navigate = useNavigate();
  const [member, setMember] = useState(null);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/membership-applications/spotlight`)
      .then(({ data }) => { if (data.enabled && data.member) setMember(data.member); })
      .catch(() => {});
  }, []);

  if (!member) return null;

  const isOrg = member.member_type === 'institutional';
  const img = isOrg ? member.logo_url : member.photo_url;
  const displayName = isOrg ? (member.organization_name || member.name) : member.name;

  return (
    <section className="py-20 bg-gradient-to-br from-[#FFF7F0] to-white" data-testid="member-spotlight-section">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <Badge className="bg-[#E87722] text-white mb-3"><Star className="h-3 w-3 mr-1" />Member Spotlight</Badge>
          <h2 className="text-3xl font-bold text-[#1E3A5F]">Celebrating Our Network</h2>
        </div>
        <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-xl p-8 md:p-10 border border-[#E87722]/20">
          <div className="flex flex-col md:flex-row items-center gap-8">
            {img ? (
              <img src={img} alt={displayName} className="h-28 w-28 rounded-full object-cover border-4 border-[#E87722]/40 flex-shrink-0" />
            ) : (
              <div className="h-28 w-28 rounded-full bg-[#1E3A5F] text-white flex items-center justify-center font-bold text-3xl flex-shrink-0">
                {displayName.split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase()}
              </div>
            )}
            <div className="text-center md:text-left">
              <h3 className="text-2xl font-bold text-[#1E3A5F]">{displayName}</h3>
              <p className="text-gray-600 mt-1">
                {isOrg
                  ? (member.organization_type || 'Institution')
                  : [member.designation, member.organization_affiliation].filter(Boolean).join(' • ')}
              </p>
              <div className="flex flex-wrap gap-2 mt-3 justify-center md:justify-start">
                <Badge className={isOrg ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'}>
                  {isOrg ? <Building2 className="h-3 w-3 mr-1" /> : <User className="h-3 w-3 mr-1" />}
                  {isOrg ? 'Institutional Member' : 'Individual Member'}
                </Badge>
                {member.selected_plan && <Badge variant="outline">{member.selected_plan}</Badge>}
              </div>
              {(member.bio || member.nature_of_business) && (
                <p className="text-gray-700 mt-4 leading-relaxed">{member.bio || member.nature_of_business}</p>
              )}
              <Button
                variant="outline"
                className="mt-5 border-[#E87722] text-[#E87722] hover:bg-[#E87722] hover:text-white"
                onClick={() => navigate('/members')}
                data-testid="spotlight-directory-btn"
              >
                Explore the Member Directory
                <ArrowRight className="h-4 w-4 ml-2" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
